import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

let configPromise = null;
export const getConfig = () => {
  if (!configPromise) {
    configPromise = axios
      .get(`${API}/config`)
      .then((r) => r.data)
      .catch(() => ({ whatsapp_number: "", brand: "Kandula Home Foods" }));
  }
  return configPromise;
};

export const waLink = (number, text) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const inr = (n) => n === null || n === undefined ? "Enquire for price" : `₹${new Intl.NumberFormat("en-IN").format(n)}`;
